import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewBlogLayer from "../components/ViewBlogLayer";

const ViewBlogPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Blog Details' />

        {/* AddBlogLayer */}
        <ViewBlogLayer />
      </MasterLayout>
    </>
  );
};

export default ViewBlogPage;